import classNames from "classnames";
import React from "react";

type WidthSimpleButtonProps = {
  isActive: boolean;
  onClick: () => void;
  children: React.ReactNode;
  variant?: "default" | "mobile-sublayout" | "wrapping-sublayout";
};

export const WidthSimpleButton = ({
  isActive,
  onClick,
  children,
  variant = "default",
}: WidthSimpleButtonProps) => {
  return (
    <button
      type="button"
      aria-pressed={isActive}
      onClick={onClick}
      className={classNames(
        "gg-relative gg-rounded-[5px] gg-border gg-border-gray-200 gg-py-3.5 gg-text-sm gg-font-bold gg-leading-relaxed gg-transition gg-duration-300 gg-ease-in-out",
        {
          "gg-px-5": variant === "default",
          "gg-block gg-max-w-full gg-overflow-hidden gg-text-ellipsis gg-whitespace-nowrap gg-text-center sm:gg-px-5":
            variant === "mobile-sublayout",
          "gg-block gg-max-w-full gg-px-2 gg-text-center":
            variant === "wrapping-sublayout",
          "gg-bg-dark-blue gg-text-white": isActive,
          "gg-bg-white gg-text-dark-blue hover:gg-bg-gray-100": !isActive,
        },
      )}
    >
      {children}
    </button>
  );
};
